import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Lightbulb, Target, Zap, MessageCircle, Users, Star, Compass, Flame, Send, Copy, Check } from 'lucide-react';
import { useState } from 'react';

const questions = [
  { id: 1, tag: "motivation", title: "Sua Motivação", icon: Heart, color: "from-pink-400 to-red-500" },
  { id: 2, tag: "guests", title: "Momento do Hóspede", icon: Users, color: "from-blue-400 to-purple-500" },
  { id: 3, tag: "delight", title: "Pequenas Surpresas", icon: Star, color: "from-yellow-400 to-orange-500" },
  { id: 4, tag: "constraints", title: "Abraçando Limites", icon: Target, color: "from-green-400 to-teal-500" },
  { id: 5, tag: "clarity", title: "Foco Cristalino", icon: Lightbulb, color: "from-purple-400 to-pink-500" },
  { id: 6, tag: "north_star", title: "Sua Estrela-Guia", icon: Compass, color: "from-indigo-400 to-blue-500" },
  { id: 7, tag: "ops", title: "Libertando a Equipe", icon: Zap, color: "from-amber-400 to-red-500" },
  { id: 8, tag: "tone", title: "Voz da Pousada", icon: MessageCircle, color: "from-teal-400 to-green-500" },
  { id: 36, tag: "love_the_problem", title: "Apaixone-se pelo Problema", icon: Flame, color: "from-red-500 to-orange-600" },
];

export default function ProblemQuestionLinks() {
  const [copiedId, setCopiedId] = useState<number | null>(null);
  const baseUrl = window.location.origin;

  const copyLink = (tag: string, id: number) => {
    const url = `${baseUrl}/problem/${tag}`;
    navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const shareLink = (tag: string, title: string) => {
    const url = `${baseUrl}/problem/${tag}`;
    const text = `Responda esta pergunta sobre ${title} e descubra insights para sua pousada:`;
    
    if (navigator.share) {
      navigator.share({
        title: title,
        text: text,
        url: url
      });
    } else {
      // Fallback to copy
      navigator.clipboard.writeText(url);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Perguntas para Compartilhar
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Cada pergunta é uma experiência completa. Envie uma por vez para sua equipe, 
            parceiros ou para você mesmo refletir com calma.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {questions.map((question) => {
            const IconComponent = question.icon;
            return (
              <div 
                key={question.id} 
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-6"
              >
                <div className={`inline-flex p-3 rounded-xl bg-gradient-to-r ${question.color} mb-4`}>
                  <IconComponent className="text-white" size={24} />
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {question.title}
                </h3>
                
                <div className="space-y-3">
                  <Link 
                    to={`/problem/${question.tag}`}
                    className={`block w-full text-center bg-gradient-to-r ${question.color} text-white py-3 px-4 rounded-xl font-medium hover:shadow-lg transition-all`}
                  >
                    Abrir Pergunta
                  </Link>
                  
                  <div className="flex gap-2">
                    <button
                      onClick={() => copyLink(question.tag, question.id)}
                      className="flex-1 bg-gray-100 text-gray-700 py-2 px-3 rounded-xl font-medium hover:bg-gray-200 transition-all flex items-center justify-center gap-2"
                    >
                      {copiedId === question.id ? (
                        <>
                          <Check size={16} />
                          Copiado!
                        </>
                      ) : (
                        <>
                          <Copy size={16} />
                          Copiar Link
                        </>
                      )}
                    </button>
                    
                    <button
                      onClick={() => shareLink(question.tag, question.title)}
                      className="flex-1 bg-blue-100 text-blue-700 py-2 px-3 rounded-xl font-medium hover:bg-blue-200 transition-all flex items-center justify-center gap-2"
                    >
                      <Send size={16} />
                      Compartilhar
                    </button>
                  </div>
                </div>
                
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <p className="text-xs text-gray-500">
                    Link direto: {baseUrl}/problem/{question.tag}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/problems"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
          >
            <Heart size={20} />
            Ver experiência completa com todas as perguntas
          </Link>
        </div>
      </div>
    </div>
  );
}